import { ComponentProps, FC } from 'react';
import { Button } from 'antd';
import { clsx } from 'clsx';
import { styled } from 'styled-components';

const StyledButton = styled(Button)`
  border-radius: 50px;
  & .ant-btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:hover {
    transform: scale(0.95);
    background-color: rgba(18, 18, 18, 0.06);
  }
`;

export const ClearButton: FC<ComponentProps<typeof Button>> = ({
  className,
  onClick,
}) => {
  return (
    <StyledButton
      type="text"
      onClick={onClick}
      icon={
        <img
          src="assets/icons/close.svg"
          alt="close"
          className={clsx(className)}
        />
      }
    />
  );
};
